var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gallery" },
    [
      _vm._l(_vm.images, function(image, i) {
        return _c(
          "a",
          {
            key: image.href,
            staticClass: "gallery__image",
            class: {
              gallery__image_current: i == _vm.imageActiveIndex,
              gallery__image_prev:
                _vm.imageActiveIndex > 0
                  ? i == _vm.imageActiveIndex - 1
                  : i == _vm.images.length - 1
            },
            attrs: { href: image.href, target: "_blank" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.$emit("image-click", i)
              }
            }
          },
          [
            _c("img", {
              attrs: { src: i == 0 ? image.large9x4 : image.medium9x4, alt: "" }
            })
          ]
        )
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass:
            "btn btn-outline-shadow-secondary gallery__button d-none d-lg-block",
          on: {
            click: function($event) {
              return _vm.$emit("image-click", 0)
            }
          }
        },
        [_vm._v(_vm._s(_vm.t.all_photos || "View all"))]
      ),
      _vm._v(" "),
      _vm.videos.length > 0
        ? _c(
            "button",
            {
              staticClass: "btn btn-clean gallery__button d-lg-none",
              on: {
                click: function($event) {
                  return _vm.$emit("video-click", 0)
                }
              }
            },
            [
              _c("img", {
                attrs: { src: "/img/Buttons/play-video-small.svg", alt: "" }
              })
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }